import { Link } from "react-router-dom";
import { Mail, Phone, Globe, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

const LOGO_WHITE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_medx-dashboard-demo/artifacts/dcjy7jep_MEDX%20AI%20Partnership%20Proposal.png";

function FlagSA() {
    return (
        <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_medx-dashboard-demo/artifacts/fpqgpkzi_images.jpg"
            alt="South African flag"
            className="w-5 h-4 rounded-sm shadow-sm object-cover shrink-0"
            draggable="false"
        />
    );
}
function FlagUK() {
    return (
        <svg viewBox="0 0 60 40" className="w-5 h-4 rounded-sm shadow-sm shrink-0" aria-hidden>
            <rect width="60" height="40" fill="#012169" />
            <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,40 M60,0 L0,40" stroke="#c8102e" strokeWidth="2.5" />
            <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 V40 M0,20 H60" stroke="#c8102e" strokeWidth="6" />
        </svg>
    );
}

export function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="bg-[#0d0d10] text-gray-300 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        <img src={LOGO_WHITE} alt="Medx AI" className="h-10 w-auto bg-white/95 rounded-lg px-2 py-1" />
                        <span className="text-xs font-mono tracking-[0.18em] text-gray-500">
                            {t("footer.tagline")}
                        </span>
                    </div>
                    <p className="text-gray-400 max-w-md leading-relaxed mb-6">
                        {t("footer.description")}
                    </p>
                    <div className="space-y-2 text-sm text-gray-400">

                        <div className="flex items-center gap-2">
                            <Globe className="w-4 h-4 text-[var(--medx-orange)]" />
                            <a href="https://www.medxai.online" target="_blank" rel="noreferrer" className="hover:text-[var(--medx-orange)]" data-testid="footer-website">www.medxai.online</a>
                        </div>
                        <div className="flex items-center gap-2">
                            <Mail className="w-4 h-4 text-[var(--medx-orange)]" />
                            <a href="mailto:info@medxai.online" className="hover:text-[var(--medx-orange)]" data-testid="footer-email">info@medxai.online</a>
                        </div>
                        <div className="flex items-center gap-2">
                            <Phone className="w-4 h-4 text-[var(--medx-orange)]" />
                            <a href="https://wa.me/27652476091" target="_blank" rel="noreferrer" className="hover:text-[var(--medx-orange)]" data-testid="footer-whatsapp">+27 65 247 6091</a>
                        </div>
                        <div className="flex items-start gap-2 pt-2" data-testid="footer-sa-office">
                            <FlagSA />
                            <div>
                                <div className="text-[11px] font-mono tracking-[0.18em] text-[var(--medx-orange)] uppercase">{t("footer.saOfficeLabel")}</div>
                                <div>{t("footer.headOffice")}</div>
                            </div>
                        </div>
                        <div className="flex items-start gap-2 pt-1" data-testid="footer-uk-office">
                            <FlagUK />
                            <div>
                                <div className="text-[11px] font-mono tracking-[0.18em] text-[var(--medx-orange)] uppercase">{t("footer.ukOfficeLabel")}</div>
                                <div>{t("footer.ukOffice")}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">{t("footer.platform")}</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/about" className="hover:text-[var(--medx-orange)]">{t("nav.about")}</Link></li>
                        <li><Link to="/solutions" className="hover:text-[var(--medx-orange)]">{t("nav.solutions")}</Link></li>
                        <li><Link to="/industries" className="hover:text-[var(--medx-orange)]">{t("nav.industries")}</Link></li>
                        <li><Link to="/our-reach" className="hover:text-[var(--medx-orange)]">{t("nav.ourReach")}</Link></li>
                        <li><Link to="/mobile-app" className="hover:text-[var(--medx-orange)]">{t("nav.mobileApp")}</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">{t("footer.account")}</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/login" className="hover:text-[var(--medx-orange)]">{t("nav.login")}</Link></li>
                        <li><Link to="/signup" className="hover:text-[var(--medx-orange)]">{t("nav.signup")}</Link></li>
                        <li><Link to="/doctor/login" className="hover:text-[var(--medx-orange)]" data-testid="footer-doctor-login">{t("footer.doctorPortal")}</Link></li>
                        <li><Link to="/employer/login" className="hover:text-[var(--medx-orange)]" data-testid="footer-employer-login">{t("footer.employerPortal")}</Link></li>
                        <li><Link to="/order" className="hover:text-[var(--medx-orange)]">{t("footer.orderKiosk")}</Link></li>
                        <li><Link to="/contact" className="hover:text-[var(--medx-orange)]">{t("footer.contactUs")}</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
                    <div>{t("footer.rights", { year: new Date().getFullYear() })}</div>
                    <div>{t("footer.builtFor")}</div>
                </div>
            </div>
        </footer>
    );
}
